import {
  useCallback,
  useEffect,
  useRef,
  KeyboardEvent as ReactKeyboardEvent
} from "react"
import { Box, BoxProps } from "@chakra-ui/react"
import { KeyControl } from "./types"
import useKeyControl, {
  KeyHandler,
  UseKeyControlOptions
} from "./useKeyControl"

const RefKeyControl = ({
  keyControl,
  handler,
  options,
  ...boxProps
}: {
  keyControl: KeyControl | KeyControl[]
  handler: KeyHandler
  options?: UseKeyControlOptions
} & Omit<BoxProps, "ref">) => {
  const ref = useKeyControl(keyControl, handler, options)
  // Render a dummy element which we can use as a DOM anchor
  // to calibrate our key handler to.
  return <Box ref={ref} {...boxProps} />
}

export default RefKeyControl
